import { render, staticRenderFns } from "./shop_import.vue?vue&type=template&id=40df8646&scoped=true&"
import script from "./shop_import.vue?vue&type=script&lang=ts&"
export * from "./shop_import.vue?vue&type=script&lang=ts&"
import style0 from "./shop_import.vue?vue&type=style&index=0&id=40df8646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df8646",
  null
  
)

export default component.exports